export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBr461VXjqZy5fFyDHl5xdQUll9A-SMYRI',
    authDomain: 'weselelive.firebaseapp.com',
    projectId: 'weselelive',
    appId: '1:292151816054:web:e14430614479d56c189457',
  },
  // Publiczny URL Cloud Function `game-api` (kod prowadzącego).
  // Po `terraform apply` w dev: terraform output -raw game_api_uri
  gameApiUrl: 'https://weselelive-game-dev-rqcufbgq6a-lm.a.run.app',
  // Publiczny URL Cloud Function `mailer` (formularz kontaktowy, cross-origin + CORS).
  // Firebase Hosting nie robi rewrite do Cloud Run w europe-central2 → wołamy wprost.
  mailerUrl: 'https://weselelive-mailer-dev-rqcufbgq6a-lm.a.run.app',
  // Bazowy URL ekranu wspólnego (projektor) — link na szczególe quizu (?g=<quizId>).
  projectorUrl: 'https://live.dev.weselelive.pl',
};
